import React, { createContext, useState, useEffect, useCallback, useContext } from "react";
import { LoggerContext } from "./LoggerContext";

export const ThemeContext = createContext({
  theme: {},
  updateTheme: () => {}
});

export const ThemeProvider = ({ children }) => {
  const { logDebug } = useContext(LoggerContext);
  const [theme, setTheme] = useState({});

  const updateTheme = useCallback((newTheme) => {
    // Vorhandenes Theme mit neuem Theme zusammenführen
    setTheme(prevTheme => ({...prevTheme, ...newTheme}));
    
    // CSS-Variablen auf das HTML-Root-Element anwenden
    Object.entries(newTheme).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
      logDebug(`Theme variable set: --${key} = ${value}`);
    });
    
    // Für Bootstrap-spezifische Variablen auch die bs- Versionen setzen
    Object.entries(newTheme).forEach(([key, value]) => {
      if (!key.startsWith('bs-') && key !== 'primary' && key !== 'secondary') {
        return;
      }
      
      // Für primäre/sekundäre Farben auch Bootstrap-Komponenten direkt beeinflussen
      if (key === 'primary' || key === 'secondary') {
        const colorName = key;
        const buttonClass = `.btn-${colorName}`;
        const colorVariable = `--bs-${colorName}`;
        
        document.documentElement.style.setProperty(colorVariable, value);
        
        // Dynamische CSS-Regeln für Bootstrap-Komponenten
        let styleEl = document.getElementById('dynamic-components-style');
        if (!styleEl) {
          styleEl = document.createElement('style');
          styleEl.id = 'dynamic-components-style';
          document.head.appendChild(styleEl);
        }
        
        // Füge die Regel dem vorhandenen Stylesheet hinzu
        const existingRules = styleEl.textContent;
        const newRule = `
          ${buttonClass} {
            --bs-btn-bg: ${value} !important;
            --bs-btn-border-color: ${value} !important;
            background-color: ${value} !important;
            border-color: ${value} !important;
          }
        `;
        
        styleEl.textContent = existingRules + newRule;
        logDebug(`Applied direct style for ${buttonClass}`);
      }
    });
  }, [logDebug]);

  // Beim ersten Laden initiale Werte setzen (falls nötig)
  useEffect(() => {
    // Hier könnten Standard-Theme-Werte gesetzt werden
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
